// Colori e misure dell'interfaccia, in un posto solo.
//
// Prima erano scritti a mano dentro i componenti (37 volte nella sola dashboard
// del cliente), con due rossi leggermente diversi e il blu di serie di Ant
// Design accanto al rosso del marchio. Cambiare un colore voleva dire aprire
// trenta file.
//
// I due caratteri sono quelli gia' in uso: AKU E KAMU per i titoli, Neue Kaine
// per il testo corrente (vedi @font-face in index.css).

// I valori qui sono esadecimali e non variabili CSS: Ant Design ne ricava le
// tinte derivate (passaggio del mouse, pressione, disabilitato) e per farlo ha
// bisogno del colore vero. Le variabili CSS equivalenti stanno in index.css e
// vanno tenute allineate a queste.
export const colori = {
    // Il rosso del logo Fit&Lab.
    primario: '#B70000',
    primarioScuro: '#8F0000',
    primarioChiaro: '#D42B2B',

    // Neutri, con una punta di caldo per non stonare con il rosso.
    inchiostro: '#1F1D1C',
    testo: '#3D3A37',
    testoTenue: '#7A756F',

    sfondo: '#F0F2F5',
    superficie: '#FFFFFF',
    superficieScura: '#2B2A28',
    bordo: '#E2E0DC',

    // Colori di stato: separati dal rosso del marchio, altrimenti un errore
    // non si distingue da un pulsante qualsiasi.
    successo: '#2E7D5B',
    attenzione: '#B26B00',
    errore: '#C62828',
};

export const caratteri = {
    titoli: "'AKU E KAMU', 'Arial Narrow', sans-serif",
    testo: "'Neue Kaine', -apple-system, 'Segoe UI', sans-serif",
};

export const misure = {
    raggio: 8,
    spazio: 8,       // unita' base: le spaziature sono multipli di questa
    altezzaTocco: 48, // minimo comodo da premere con il pollice
};

// Configurazione per il ConfigProvider di Ant Design: da qui in poi bottoni,
// campi, tabelle e messaggi usano i colori del marchio invece di quelli di serie.
export const temaAntd = {
    token: {
        colorPrimary: colori.primario,
        colorLink: colori.primario,
        colorLinkHover: colori.primarioChiaro,
        colorSuccess: colori.successo,
        colorWarning: colori.attenzione,
        colorError: colori.errore,
        colorText: colori.testo,
        colorTextHeading: colori.inchiostro,
        colorTextDescription: colori.testoTenue,
        colorBgLayout: colori.sfondo,
        colorBgContainer: colori.superficie,
        colorBorder: colori.bordo,
        borderRadius: misure.raggio,
        fontFamily: caratteri.testo,
        fontSize: 15,
    },
    components: {
        Button: {
            controlHeight: misure.altezzaTocco,
            fontWeight: 600,
        },
        Input: { controlHeight: misure.altezzaTocco },
        Select: { controlHeight: misure.altezzaTocco },
        InputNumber: { controlHeight: misure.altezzaTocco },
        Modal: { borderRadiusLG: misure.raggio },
    },
};

export default temaAntd;
